import { BaseDTO } from "src/app/Models/ApiV2/BaseDTO";
import { CuentaContableDTO } from "./CuentaContableDTO";
import { FormaPagoDTO } from "./FormaPagoDTO";
import { CategoriaDTO } from "./CategoriaDTO";
import { ficherosGetDTO } from "./FicherosGetDTO";
import { TerritorioDTO } from "./TerritorioDTO";
import { EntidadCodigoStringDTO } from "./EntidadCodigoStringDTO";
import { EntidadCodigoIntDTO } from "./EntidadCodigoIntDTO";
import { FicherosRegistros } from "./FicherosRegistrosDTO";


export class ClienteDTO extends BaseDTO {
    datosFiscales?:DatosFiscalesDTO;
    nombre?: string;
    codigo?: string;
    referenciaExterna?: string;
    nombreComercial?: string;
    observaciones?: string;
    modalidadFiscal?: number
    iva?:number;
    cuentaContable?:CuentaContableDTO;
    cuentaContrapartida?:CuentaContableDTO;
    formaPago?: EntidadCodigoIntDTO;
    tipo?: number;
    cuentasBancarias?: CuentaBancariaDTO[];
    categorias?: CategoriaDTO[];
    vendedores?: AgenteTerceroDTO[];
    condicionesEconomicas?: CondicionesEconomicasTerceroDTO[];
    rutas?: RutasTerceroDTO[];
    zona?: ZonaDTO;
    domiciliosEnvio?: DomicilioGestionDTO[];
    referenciaAuxiliar?: string;
    diaPago1?: number;
    diaPago2?: number;
    diaPago3?: number;
    mesNoPago?: number;
    activo?: number | boolean;
    suspendeFacturacion?: number | boolean;
    descansoSemanal?: number;
    referenciaOtraParte?: string;
    varios?: number;
    aplicarIrpf?: boolean
    paginaWeb?: string;
    fechaNacimiento?: Date | string;
    sexo?: number;
    codigoEDI?: string;
    agruparAlbaranes?: boolean
    telefonos?: TelefonoDTO[]
    emails?:EmailDTO[]
    codigoROPO?: string
    //numeroCarnetFitosanitario
    //identificacionRespuesta
    //faceOficinaContable
    //faceOrganoGestor
    //faceUnidadTramitadora
    //faceOrganoProponente
    AsignarCuentaContableAutomatica?: boolean;
    imagenes ? : ficherosGetDTO[]

}

export class ProveedorDTO extends BaseDTO {
    datosFiscales?:DatosFiscalesDTO;
    nombre?: string;
    codigo?: string;
    referenciaExterna?: string;
    nombreComercial?: string;
    observaciones?: string;
    modalidadFiscal?: number
    iva?:number;
    cuentaContable?:CuentaContableDTO;
    cuentaContrapartida?:CuentaContableDTO;
    formaPago?: EntidadCodigoIntDTO;
    tipo?: number;
    cuentasBancarias?: CuentaBancariaDTO[];
    categorias?: CategoriaDTO[];
    vendedores?: AgenteTerceroDTO[];
    condicionesEconomicas?: CondicionesEconomicasTerceroDTO[];
    rutas?: RutasTerceroDTO[];
    zona?: ZonaDTO;
    domiciliosEnvio?: DomicilioGestionDTO[];
    referenciaAuxiliar?: string;
    diaPago1?: number;
    diaPago2?: number;
    diaPago3?: number;
    mesNoPago?: number;
    activo?: number | boolean;
    suspendeFacturacion?: number | boolean;
    descansoSemanal?: number;
    referenciaOtraParte?: string;
    varios?: number;
    aplicarIrpf?: boolean
    paginaWeb?: string;
    fechaNacimiento?: Date | string;
    sexo?: number;
    codigoEDI?: string;
    agruparAlbaranes?: boolean
    telefonos?: TelefonoDTO[]
    emails?:EmailDTO[]
    codigoROPO?: string
    //numeroCarnetFitosanitario
    //identificacionRespuesta
    //faceOficinaContable
    //faceOrganoGestor
    //faceUnidadTramitadora
    //faceOrganoProponente
    AsignarCuentaContableAutomatica?: boolean;
    imagenes ? : ficherosGetDTO[]

}

export class DatosFiscalesDTO extends BaseDTO{
    nombre?: string;
    nombrePFisica?: string;
    apellidosPFisica?: string;
    tipoEntidad?: number;
    nif?: string;
    nifRepresentante?: string;
    paisIdentificacion?: string;
    tipoIdentificacion?: number;
    numeroIdentificacion?: string;
    domicilioFiscal?: DomicilioDTO
}

export class DomicilioDTO extends BaseDTO {
    domicilio?: string;
    ampliacionDomicilio?: string;
    pais?: TerritorioDTO;
    region?: TerritorioDTO;
    provincia?: TerritorioDTO;
    poblacion?: TerritorioDTO;
    localidad?: TerritorioDTO;
    barrio?: string;
    codigoPostal?: TerritorioDTO;
    latitud?: number;
    longitud?: number;
    telefonos?: TelefonoDTO[];
    emails?: EmailDTO[];
}

export class CuentaBancariaDTO extends BaseDTO {
    entidadBancaria?: string
    sucursalBancaria?: string
    digitoControl?: string
    numeroCuenta?: string
    iban: string
    swift: string
    bic: string
    referenciaExterna?: string
} 

export class AgenteTerceroDTO extends BaseDTO {
    nivel?: number;
    fechaInicial?: Date | string;
    fechaFinal?: Date | string;
    referenciaExterna?: string;
    tercero?:EntidadCodigoStringDTO;
    agente?: EntidadCodigoStringDTO;
}

export class CondicionesEconomicasTerceroDTO extends BaseDTO {
    tercero?: EntidadCodigoStringDTO;
    fechaInicial?: Date | string;
    fechaFinal?: Date | string;
    referenciaExterna?: string;
    descuento1?: number;
    descuento2?: number;
    descuento3?: number;
    descuento4?: number;
    riesgo?: number;
    riesgoAsegurado?: number;
    valorPuntos?: number;
    perfilEconomico?: EntidadCodigoStringDTO;
    tarifaPrecios?: EntidadCodigoStringDTO;
    tarifaDescuentos?: EntidadCodigoStringDTO;
    identificacionRespuesta?: string
}

export class RutasTerceroDTO extends BaseDTO {
    referenciaExterna?: string;
    codigo?: string;
    nombre?: string;
    orden?: number;
}

export class ZonaDTO extends EntidadCodigoStringDTO {
}

export class DomicilioGestionDTO extends DomicilioDTO {
    codigo?: number;
    referencia?: string;
    tipo?: number;
    tipoTexto?: number;
    nombre?: string;
    razonSocial?: string;
    nif?: string;
    identificacionRespuesta?: string
}

export class TelefonoDTO {
    id?: number;
    tipo?: number;
    tipoNombre?: string;
    telefono?: string;
}

export class EmailDTO {
    id?: number;
    tipo?: number;
    tipoNombre?: string;
    email?: string;
}

export class agenteDTO extends BaseDTO {
    codigo?: string;
    referenciaExterna?: string;
    nombre?: string;
    nombreComercial?: string;
    nif?: string;
    domicilio?: DomicilioDTO;
    fechaDesactivacion?: Date | string;
    observaciones?: string;
    categorias?:CategoriaDTO;
    telefonos?: TelefonoDTO[];
    emails?: EmailDTO[];
    imagenes?: ficherosGetDTO[];
}

export class AlmacenDTO extends BaseDTO {
    codigo: string;
    nombre: string;
    referenciaExterna: string;
    tipo: number;
    domicilioUbicacion: DomicilioDTO
}